module.exports = __webpack_public_path__ + "img/pain-level.9a14a99c.svg";